import { FunctionComponent } from 'preact';
import debounce from 'lodash/debounce';
import { useEffect } from 'preact/hooks';

const BuyingOptionsPagination: FunctionComponent<BuyingOptionsPaginationProps> = ({
    scrollLeft,
    scrollRight,
    syncScroll,
    disablePaginationButtonsCheck,
    nextButtonIsDisabled,
    prevButtonIsDisabled
}) => {
    useEffect(() => {
        // Listen for table scroll events
        const tableContainers = document.querySelectorAll<HTMLElement>(
            '[data-buying-options-container]'
        );
        tableContainers.forEach(table => {
            table.addEventListener('scroll', debounce(disablePaginationButtonsCheck, 100));
        });
        tableContainers.forEach(table => {
            table.addEventListener('scroll', e => {
                syncScroll(e.target);
            });
        });
    }, []);

    return (
        <div class="buying-options__pagination" data-buying-options-pagination>
            <button
                class={`buying-options__pagination-button prev btn btn-primary ${
                    prevButtonIsDisabled ? 'disabled' : ''
                }`}
                disabled={prevButtonIsDisabled}
                aria-disabled={prevButtonIsDisabled}
                onClick={() => {
                    scrollLeft();
                }}
            >
                <i
                    class="buying-options__pagination-chevron chevron-left d-inline-block mr-2"
                    aria-hidden="true"
                ></i>
                <span>Previous Size</span>
            </button>
            <button
                class={`buying-options__pagination-button next btn btn-primary ${
                    nextButtonIsDisabled ? 'disabled' : ''
                }`}
                disabled={nextButtonIsDisabled}
                aria-disabled={nextButtonIsDisabled}
                onClick={() => {
                    scrollRight();
                }}
            >
                <span>Next Size</span>
                <i
                    class="buying-options__pagination-chevron d-inline-block ml-2"
                    aria-hidden="true"
                ></i>
            </button>
        </div>
    );
};

interface BuyingOptionsPaginationProps {
    scrollLeft: () => void;
    scrollRight: () => void;
    syncScroll: (e: EventTarget | null) => void;
    disablePaginationButtonsCheck: () => void;
    nextButtonIsDisabled: boolean;
    prevButtonIsDisabled: boolean;
}

export default BuyingOptionsPagination;
